module.exports = __webpack_public_path__ + "static/img/amg-1.1e9e5e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/amg-1.jpg
// module id = kE7E
// module chunks = 1